import { t } from "i18next";

function Page404() {

  return (
    <>
      {t('title.page_not_found')}
    </>
  );
}

export default Page404;